// src/components/PlanetIcon.jsx

const icons = {
  Sun: "☉",
  Moon: "☾",
  Mars: "♂",
  Mercury: "☿",
  Jupiter: "♃",
  Venus: "♀",
  Saturn: "♄",
  Rahu: "☊",
  Ketu: "☋",
};

/* Subtle UI Tints (Not literal astrology colors) */
const planetTints = {
  Sun: "#fbbf24",       // warm amber
  Moon: "#cbd5e1",      // soft silver
  Mars: "#f87171",      // muted red
  Mercury: "#60a5fa",   // cool blue
  Jupiter: "#a78bfa",   // soft violet
  Venus: "#f472b6",     // gentle rose
  Saturn: "#94a3b8",    // slate
  Rahu: "#22d3ee",      // teal mist
  Ketu: "#c084fc",      // subtle purple
};

export default function PlanetIcon({ planet, size = 20 }) {
  const color = planetTints[planet] || "#e5e7eb";

  return (
    <span
      style={{
        fontSize: size,
        lineHeight: 1,
        marginRight: 8,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color,
        opacity: 0.95,
        fontFamily:
          "Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif",
        filter: "drop-shadow(0 0 4px rgba(0,0,0,0.35))",
      }}
    >
      {icons[planet] || "★"}
    </span>
  );
}